/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetGoogleClassroomAccessStatusResponseContent
 */
export interface GetGoogleClassroomAccessStatusResponseContent {
    /**
     * 
     * @type {boolean}
     * @memberof GetGoogleClassroomAccessStatusResponseContent
     */
    delegated: boolean;
}


/**
 * Check if a given object implements the GetGoogleClassroomAccessStatusResponseContent interface.
 */
export function instanceOfGetGoogleClassroomAccessStatusResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "delegated" in value;
    return isInstance;
}

export function GetGoogleClassroomAccessStatusResponseContentFromJSON(json: any): GetGoogleClassroomAccessStatusResponseContent {
    return GetGoogleClassroomAccessStatusResponseContentFromJSONTyped(json, false);
}

export function GetGoogleClassroomAccessStatusResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGoogleClassroomAccessStatusResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'delegated': json['delegated'],
    };
}

export function GetGoogleClassroomAccessStatusResponseContentToJSON(value?: GetGoogleClassroomAccessStatusResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'delegated': value.delegated,
    };
}

